/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ItemDto } from '../models/ItemDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ItemInstanceService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all items for a particular user from the DB.
     * @param orgGuid
     * @param userGuid
     * @returns ItemDto OK
     * @throws ApiError
     */
    public getUserItemDtos(
        orgGuid: string,
        userGuid?: string,
    ): CancelablePromise<Array<ItemDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ItemInstance/{orgGuid}/GetUserItemDtos',
            path: {
                'orgGuid': orgGuid,
            },
            query: {
                'userGuid': userGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all items for an org from the DB.
     * @param orgGuid
     * @param userGuid
     * @returns ItemDto OK
     * @throws ApiError
     */
    public getAllItemDtos(
        orgGuid?: string,
        userGuid?: string,
    ): CancelablePromise<Array<ItemDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ItemInstance/GetAllItemDtos',
            query: {
                'orgGuid': orgGuid,
                'userGuid': userGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
